import { toObjectMap } from "@@/utilities/dictionary";

const aspectRatios = [
    "1:1",
    "2:3",
    "3:2",
    "3:4",
    "4:3",
    "9:16",
    "16:9",
] as const;
type AspectRatio = (typeof aspectRatios)[number];
const aspectRatio = toObjectMap<AspectRatio>([...aspectRatios]);

export { aspectRatio, aspectRatios };
export type { AspectRatio };
